module.exports = __webpack_public_path__ + "static/media/work-mifold.89fca912.jpg";